// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"e74aea4d","256":"17da10c2","871":"611f7e5a"}[chunkId] + ".chunk.js";
};